import React, { useState, useEffect, useCallback, useRef } from 'react';
import ContactLaptopSvg from '../../assets/images/contact-laptop.svg'
import { useDispatch } from 'react-redux';
import { addPageSpinner, removePageSpinner } from '../../Store/Actions/spinner';
import { Link, useNavigate, useParams } from 'react-router-dom';
import ApiService from '../../Services/ApiService';
import { ERROR_KEY } from '../../Constants/MainKeys';
import AlertService from '../../Services/AlertService';
import uuid from 'react-uuid';
import MainService from '../../Services/MainService';
import moment from 'moment';


export default function TicketAnswerComponent() {

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { ticketNumber } = useParams();
  const [currentTicket, setCurrentTicket] = useState(null);

  useEffect(() => {
    getTicketByTicketNumber(ticketNumber)
  }, [ticketNumber])

  const getTicketByTicketNumber = (ticketNumber) => {
    if (!ticketNumber) { return false }
    const spinnerId = uuid();
    setPageSpinner(spinnerId)
    ApiService.getTicketByTicketNumber(ticketNumber).then(response => {
      if (response && response.data && response.data.data) {
        setCurrentTicket(response.data.data);
      }
    }).catch(error => getFail(error)).finally(() => {
      extractPageSpinner(spinnerId)
    })
  }

  const setPageSpinner = useCallback(spinner => {
    dispatch(addPageSpinner(spinner));
  }, []);

  const extractPageSpinner = useCallback(spinner => {
    dispatch(removePageSpinner(spinner));
  }, []);

  const getFail = (error) => {
    error && AlertService.alert(AlertService.checkMessageType(error.respcode) || ERROR_KEY, error);
    navigate("/")
  };

  if (!currentTicket) { return false; }

  return <div className="row">
    <div className="col-lg-6 mt-5">

      <div className='ticket-component border rounded'>

        <div className='ticket-chat p-3'>
          <div className=' d-flex flex-column gap-3'>
            <div className='d-flex justify-content-end message-right' >
              <div className='py-2 px-3' style={{ width: '100%', borderRadius: "10px", backgroundColor: currentTicket.isClientAnswer ? "#D9E9F9" : "#D4EFE7" }}>
                <p className='mb-0' style={{ wordBreak: "break-all" }}>{currentTicket?.message}</p>
                <small className='d-block text-end fw-500'>{moment(MainService.convertUTCDateToLocalDate(new Date(currentTicket.createTime))).format('HH:mm ll ')}</small>
              </div>
            </div>
            {
              currentTicket.ticketAnswers && currentTicket.ticketAnswers.length ? (
                currentTicket.ticketAnswers.map((item, index) => {
                  const justifyClass = item.isClientAnswer ? 'justify-content-end message-right' : 'justify-content-start message-left';
                  const bgColor = item.isClientAnswer ? '#D4EFE7' : '#D9E9F9';
                  return (
                    <div key={index} className={`d-flex ${justifyClass}`}>
                      <div className="px-3 py-2 pb-1" style={{ maxWidth: '80%', borderRadius: '10px', backgroundColor: bgColor }}>
                        <p style={{ wordBreak: "break-all" }}>{item?.answer}</p>
                        <small className="d-block text-end fw-500">
                          {moment(MainService.convertUTCDateToLocalDate(new Date(item.createTime))).format('HH:mm ll')}
                        </small>
                      </div>
                    </div>
                  );
                })
              ) : null
            }
          </div>
        </div>
      </div>
    </div>
    <div className="col-lg-6 d-lg-block d-none px-5 mt-5">
      <p>
        This page shows your support ticket and our responses. If you have any updates or further questions, feel free to reply below.
      </p>
      <p>
        Need general info? Check out the <Link to="/faq" target="_blank">Cryllex FAQ</Link> for commonly asked questions.
      </p>
      <div className="text-center">
        <img className="cx--aside-image" src={ContactLaptopSvg} alt="support-ticket" />
      </div>
    </div>

  </div>
}
